"use client"

import React, { useState } from "react"

import useNavatticEmbedScript from "@/hooks/useNavatticEmbedScript"
import LoadingOverlay from "@/ui/components/LoadingOverlay"

const DemoPaymentsPage: React.FC = () => {
  const [isLoaded, setIsLoaded] = useState(false)

  useNavatticEmbedScript()

  return (
    <>
      {!isLoaded && <LoadingOverlay />}
      <iframe
        data-navattic-src="https://capture.navattic.com/split/cmcnp9fhq0001w1k1gvm0ger4"
        allow="fullscreen"
        className="fixed border-none top-0 left-0 bottom-0 right-0 w-full h-full m-0 p-0 z-[999999]"
        title="Navattic Demo"
        onLoad={() => setIsLoaded(true)}
      />
    </>
  )
}

export default DemoPaymentsPage
